import { rei } from "@/services/api"

class CartorioConfigService {
  static showByChave (params) {
    return rei.get('get-by-chave', { params }).then(res => res.data)
  }

  static updateByChave (data) {
    return rei.put(`update-cartorio-config-by-chave`, data).then(res => res.data)
  }

  static bulkUpdateByChave (data) {
    return rei.put(`bulk-update-cartorio-config-by-chave`, {keys: data}).then(res => res.data)
  }

  static getAlertaImpressos () {
    return rei.get(`get-alerta-impressos`).then(res => res.data)
  }

  static listAlertaImpressos () {
    return rei.get(`list-alerta-impressos`).then(res => res.data)
  }
}

export default CartorioConfigService
